import Axios from 'axios';
import React, { useEffect, useState } from 'react'
import Header from '../components/Header';
import InfoList from '../components/InfoList';

export const List = ({ match, ...props }) => {
    const { id } = (match.params);
    const [loading, setLoading] = useState(false);
    const [list,setList]=useState([]);
    const [data, setData] = useState({
        page: 1,
        pageCount: 0,
        cate: {
            name: ''
        },
    });
    const take = 30;

    const loadData = async (page) => {
        setLoading(true);
        const res = await Axios.post(`/api/info/slist/${id}`, {
            page: page,
            take
        })
        setData(res.data);
        setList([...list,...res.data.list]);
        setLoading(false);
    }
    useEffect(() => {
        loadData(1)
    }, [id])
    const nextPage = () => {
        let page = data.page + 1;
        loadData(page);
    }
    return (
        <div>
            <Header title={data.cate.name} />
            <div>
                <InfoList list={list} />
            </div>
            {!loading && data.pageCount>data.page && (

                <div className='mt-2 load-more-wrap'>
                    <a onClick={nextPage}>加载更多...</a>
                </div>
            )}
        </div>
    )
}
